import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type * as models from '../models'

import * as dynamicEc from './ec'
import type { Feature } from './feature'

/** Selectors for dynamically created Mosaic widget entity collections. */
export class Selectors {
  /** Gets the dynamic entity collection associated with a widget reference. */
  public readonly getDynamicEc

  /** Creates selectors for dynamic entity collections. */
  constructor(feature: Feature) {
    this.getDynamicEc = feature.createSelectorMethod(
      (ref: models.widget.Ref) => () => {
        const collection = ec.Collection.instances.tryGet(
          dynamicEc.Name.from(ref),
        ).collection

        if (collection) {
          return collection
        }

        return ec.Collection.instances.find<dynamicEc.Name>({
          isName: name => dynamicEc.Name.isForReference(name, ref),
        }).collections[0]
      },
    )
  }
}
